"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any*/
//justification: exposing the same interface as the underlying logger
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogger = void 0;
/**
 * Logger implementation that utilizes the applications default console logger
 */
class ConsoleLogger {
    /**
     * Logs a message at debug level
     * @param message The log message
     * @param optionalParams Any optional params; will be passed through to the underlying console.logLevel() call, so behaviour will be the same as standard logging
     */
    debug(message, ...optionalParams) {
        console === null || console === void 0 ? void 0 : console.debug(message, ...optionalParams);
    }
    /**
     * Logs a message at info level
     * @param message The log message
     * @param optionalParams Any optional params; will be passed through to the underlying console.logLevel() call, so behaviour will be the same as standard logging
     */
    info(message, ...optionalParams) {
        console === null || console === void 0 ? void 0 : console.info(message, ...optionalParams);
    }
    /**
     * Logs a message at warning level
     * @param message The log message
     * @param optionalParams Any optional params; will be passed through to the underlying console.logLevel() call, so behaviour will be the same as standard logging
     */
    warn(message, ...optionalParams) {
        console === null || console === void 0 ? void 0 : console.warn(message, ...optionalParams);
    }
    /**
     * Logs a message at error level
     * @param message The log message
     * @param optionalParams Any optional params; will be passed through to the underlying console.logLevel() call, so behaviour will be the same as standard logging
     */
    error(message, ...optionalParams) {
        console === null || console === void 0 ? void 0 : console.error(message, ...optionalParams);
    }
    /**
     * Logs a message at error level (js console logger does not have a critical log level)
     * @param message The log message
     * @param optionalParams Any optional params; will be passed through to the underlying console.logLevel() call, so behaviour will be the same as standard logging
     */
    critical(message, ...optionalParams) {
        console === null || console === void 0 ? void 0 : console.error(message, ...optionalParams);
    }
}
exports.ConsoleLogger = ConsoleLogger;
